import { createBreakpoints } from '@chakra-ui/theme-tools';
var breakpoints = createBreakpoints({
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
});
var breakpoints$1 = breakpoints;
export { breakpoints$1 as default };